import script from "./AdminLoginPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminLoginPage.vue?vue&type=script&setup=true&lang=js"

import "./AdminLoginPage.vue?vue&type=style&index=0&id=0c31c89e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c31c89e"]])

export default __exports__